<template>
  <b-container class="site-detail__reportsettings contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('config.reportsettings')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button class="btn btn--success" v-on:click="save">
              <span class="btn__icon">
                  <font-awesome-icon class="icon" :icon="['fal','save']"></font-awesome-icon>
              </span>
              {{$t('config.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <div v-html="$t('config.reportintro')"></div>
        <b-form-group :label="$t('config.email')">
          <b-form-input v-model="reportEmail"
                        type="email"
                        placeholder="Enter Email"
                        id="mail">

          </b-form-input>
        </b-form-group>
        <b-form-group :label="$t('config.contactperson')">
          <b-form-input v-model="reportContactPerson"
                        type="text"
                        placeholder="Contact Person Name"
                        id="contactperson">

          </b-form-input>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="sendReport"
          >
            {{$t('config.sendreport')}}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="sendCopy"
          >
            {{$t('config.sendcopy')}}
          </b-form-checkbox>
        </b-form-group>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailSettingsReport',

  mixins: [mixins],

  computed: {

    ...mapState('site', [
      'siteDetail'
    ])
  },

  data () {
    return {
      currentSavedValues: {},
      sendReport: false,
      sendCopy: false,
      reportEmail: '',
      reportContactPerson: ''
    }
  },

  watch: {

    'siteDetail': function () {
      this.preparePage()
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageConfiguration'
    ]),

    ...mapActions('site', [
      'saveSiteConfiguration',
      'saveSitePlan'
    ]),

    hasConfigurationChanged () {
      return (this.currentSavedValues['send_copy'] !== this.sendCopy) ||
            (this.currentSavedValues['send_report'] !== this.sendReport) ||
            (this.currentSavedValues['report_contactperson'] !== this.reportContactPerson) ||
            (this.currentSavedValues['report_email'] !== this.reportEmail)
    },

    preparePage () {
      // check for initial state
      if (this.siteDetail.data.configuration === null) {
        // default value
        this.sendReport = false
        this.sendCopy = false
        this.reportEmail = ''
        this.reportContactPerson = ''
      }

      if (this.siteDetail.data.configuration !== null) {
        let sendCopy = this.getConfigValue(
          this.siteDetail.data.configuration,
          'send_copy',
          -1
        )
        if (sendCopy === -1) {
          // not set yet
          sendCopy = false
        }
        this.currentSavedValues['send_report'] = sendCopy
        this.sendCopy = sendCopy

        let sendReport = this.getConfigValue(
          this.siteDetail.data.configuration,
          'send_report',
          -1
        )

        if (sendReport === -1) {
          // not set yet
          sendReport = false
        }

        this.currentSavedValues['send_report'] = sendReport

        this.sendReport = sendReport

        let reportEmail = this.getConfigValue(
          this.siteDetail.data.configuration,
          'report_email',
          ''
        )

        this.currentSavedValues['report_email'] = reportEmail

        this.reportEmail = reportEmail

        let reportContactPerson = this.getConfigValue(
          this.siteDetail.data.configuration,
          'report_contactperson',
          ''
        )

        this.currentSavedValues['report_contactperson'] = reportContactPerson

        this.reportContactPerson = reportContactPerson
      }
    },

    save () {
      if (this.hasConfigurationChanged()) {
        let payload = {
          id: this.siteDetail.id,
          configuration: {
            'report_email': this.reportEmail,
            'report_contactperson': this.reportContactPerson,
            'send_report': this.sendReport,
            'send_copy': this.sendCopy
          }
        }

        this.saveSiteConfiguration(payload)
      }
    }
  }
}
</script>
